// @mui
import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// auth
import { useAuthContext } from '../../auth/useAuthContext';
// layouts
import LoginLayout from '../../layouts/login';
//
import AuthLoginForm from './AuthLoginForm';
import AuthWithSocial from './AuthWithSocial';

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Log in to Portal Doctrine UK</Typography>

        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2">New user?</Typography>

          <Link variant="subtitle2" href="/census/">Request an account</Link>
        </Stack>

      </Stack>

      <Alert severity="info" sx={{ mb: 3 }}>
        Click &quot;Log in with Google&quot; button below and log in with your <strong>@doctrineuk.org</strong> email
      </Alert>

      <AuthWithSocial />
    </LoginLayout>
  );
}
